import React, { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import './SiteDataGrid.scss';
import {
    ClientSideRowModelModule,
    MasterDetailModule,
    ModuleRegistry,
    themeMaterial,
} from 'ag-grid-enterprise';
import { SiteDataGridLogic, getDetailCellRendererParams, getGridOptions } from './SiteDataGrid';

ModuleRegistry.registerModules([ClientSideRowModelModule, MasterDetailModule]);

function SiteDataGrid() {
    const gridRef = useRef(null);
    const { transformedData, columnDefs, detailColumnDefs, loading, overlayComponentSelector } = SiteDataGridLogic();

    const detailCellRendererParams = getDetailCellRendererParams(detailColumnDefs);
    const gridOptions = getGridOptions(columnDefs, transformedData, detailCellRendererParams);

    return (
        <div className='site-data-grid-wrapper'>
            <div className='header'><h2>Site Data</h2></div>
            <div className='ag-theme-quartz site-data-grid' style={{ height: '600px', width: '100%' }}>
                <AgGridReact loading={loading} overlayComponentSelector={overlayComponentSelector} theme={themeMaterial} ref={gridRef} {...gridOptions} />
            </div>
        </div>
    )
}

export default SiteDataGrid
